import { Cookie } from '@vue-util/cookie';
import UserStatus from '@common-vue/util/src/modules/cookie/UserStatus';

export class PdpUserStatus extends UserStatus {
  static is365Customer() {
    return Cookie.get('Login365Customer', 'MISCGCs') === 'Y';
  }
}

export default PdpUserStatus;
